import { combineReducers } from 'redux';
import {
  reducer as socialLogin,
  State as SocialState,
} from '@src/app/login/social/reducer';
import {
  reducer as weakLogin,
  State as WeakState,
} from '@src/app/login/weak/reducer';
import {
  reducer as accountPostalCode,
  State as AccountPostalCodeState,
} from '@src/app/login/weak/accountpostalcode/reducer';
import {
  reducer as emailPostalCode,
  State as EmailPostalCodeState,
} from '@src/app/login/weak/emailpostalcode/reducer';
import {
  reducer as nameAddress,
  State as NameAddressState,
} from '@src/app/login/weak/nameaddress/reducer';
import {
  reducer as omsAuth,
  State as OmsState,
} from '@src/app/login/oms/reducers';

interface StoreEnhancerState {}

export interface AuthState extends StoreEnhancerState {
  socialLogin: SocialState;
  weakLogin: WeakState;
  accountPostalCode: AccountPostalCodeState;
  nameAddress: NameAddressState;
  omsAuth: OmsState;
  emailPostalCode: EmailPostalCodeState;
}

export const reducer = combineReducers<AuthState, any>({
  socialLogin,
  weakLogin,
  accountPostalCode,
  omsAuth,
  emailPostalCode,
  nameAddress,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/reducers.ts